import React, { useRef, useState } from "react";
import { useSelector } from 'react-redux';
import useClickOutside from "../../../hooks/useClickOutside";
import Moment from 'moment';
import classes from './ProjectActionPopup.module.css'
import { onKeyDown } from "../../../service";
import Loader from "../../lms-shared/UI/Loader/Loader";


const ProjectActionPopup = ({ versions, saveFunc, saveCopyVersion, loadFunc, closePopup, assessmentName, setShowProjectActionPopup }) => {
    const { direction, texts } = useSelector((state) => state.translate);
    const [versionIdToRestore, setVersionIdToRestore] = useState(null)
    const [loader, setLoader] = useState(false);
    const popupRef = useRef(null);

    const handleLoadVersion = () => {
        if (versionIdToRestore) {
            loadFunc(versionIdToRestore);
            localStorage.removeItem("reloadCount")
        }
        setVersionIdToRestore(null)
    }

    useClickOutside(popupRef, () => {
        setShowProjectActionPopup(false);
    });

    return (
        <div className={`${classes[direction]} ${classes.ProjectActionPopup}`} ref={popupRef}>
            {loader ? <Loader /> :
                <> <div className={classes.Header} onClick={closePopup}>
                    <div className={classes.AassessmentName}>{assessmentName}</div>
                    <div className={`${classes.Icon} ${classes.Circle}`} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, closePopup)}>
                        <div className={classes.XLine}></div>
                        <div className={`${classes.XLine} ${classes.Rotate}`}></div>
                    </div>
                    {/* <div className={classes.HeaderStatus}> ({texts.save})</div> */}
                </div>
                    <div className={classes.PopupContent}>
                        {/* <div className={classes.StatusText}>{texts.status}: {texts.save}</div> */}
                        <div>{texts.recentlySaved}: {Moment(versions.find(v => v.isCurrent).createdDate).format('DD.MM  HH:mm')}
                            <div>{texts.version}: {versions.find(v => v.isCurrent).id.slice(versions.find(v => v.isCurrent).id.length - 7)}</div>
                        </div>
                        <div className={classes.SaveBtns}>
                            {/* <div className={`${classes.SaveBtn} ${classes.Btn}`} onClick={saveFunc} style={{ background: "#C4C4C4" }}>{texts.save}</div> */}
                            <div className={`${classes.SaveBtn} ${classes.Btn}`} onClick={() => saveFunc(setLoader)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => saveFunc())}>{texts.save}</div>
                            <div className={`${classes.SaveCopyBtn} ${classes.Btn}`} onClick={() => saveCopyVersion(setLoader)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, saveCopyVersion)} >{texts.saveCopy}</div>
                        </div>
                        <div className={classes.VersionsWrapper}>
                            <div className={classes.VersionsHistory}>{texts.versionsHistory}</div>
                            <div className={classes.ChooseVersions}>{texts.chooseVersionsToRestore}</div>
                            <div className={classes.VersionsTable}>
                                <div className={classes.VersionsTableTitle}>
                                    <div className={`${classes.Version} ${classes.Field}`}>{texts.version}</div>
                                    <div className={`${classes.UpdateDate} ${classes.Field}`}>{texts.updateDate}</div>
                                </div>
                                <div className={classes.VersionsTableRows}>
                                    {versions && versions.length > 0 && versions.map((v, i) =>
                                        <div className={`${classes.Row} ${v.id === versionIdToRestore && classes.current}`} key={i} onClick={() => setVersionIdToRestore(v.id)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setVersionIdToRestore(v.id))}>
                                            {/* <div className={`${classes.Row} ${v.id === versionIdToRestore && classes.current}`} key={i} onClick={() => setVersionIdToRestore(i)}> */}
                                            <div className={`${classes.VersionId} ${classes.Field}`}>{v.id.slice(v.id.length - 7)}</div>
                                            <div className={`${classes.Date} ${classes.Field}`}>
                                                <div className={classes.Day}>{Moment(v.createdDate).format('DD.MM')}</div>
                                                <div className={classes.Hour}>{Moment(v.createdDate).format('HH:mm')}</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={`${classes.RestoreVersionBtn} ${!versionIdToRestore ? classes.DisabledBtn : null} ${classes.Btn}`} onClick={handleLoadVersion} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, handleLoadVersion)}>{texts.restoreVersion}</div>
                        </div>
                    </div>
                </>}
        </div>
    )
}

export default ProjectActionPopup